(function mjsGwp0074CartHelper() {
  'use strict';

  var VERSION = '1.2.0-pilot-release-window';
  var REQUIRED_LIVE_ACTIVATION_STATE = 'ALL_BACKEND_AND_STOREFRONT_UAT_PASSED';
  var REQUIRED_PILOT_ACTIVATION_STATE = 'GUARDED_LIVE_UAT_WINDOW_AUTHORISED';
  var REQUIRED_UAT_ACTIVATION_STATE = 'UNPUBLISHED_RC_UAT_AUTHORISED';
  var AUTHORITY_SHA256 = 'd2849d0a8a170fc9f3f9ce6ce929891533245c513440ae41836d5a9da34f856f';
  var GIFT_SKU = 'GWP0074';
  var LEGACY_SKU = 'GWP069';
  var LEGACY_PRODUCT_ID = '10423994515749';
  var LEGACY_VARIANT_ID = '52263099859237';
  var LEGACY_PROPERTY_KEY = '_mjs_najo_gwp';
  var LEGACY_PROPERTY_VALUE = 'najo-signature-travel-pouch';
  var FAILED_PROBE_KEY = 'mjs:gwp0074:last-failed-cart-signature';
  var PRODUCTION_HOSTNAMES = Object.freeze([
    'myjewelleryshop.com.au',
    'www.myjewelleryshop.com.au'
  ]);

  var ELIGIBLE_PRODUCT_IDS = Object.freeze([
    '10026765222181',
    '10026765254949',
    '10026765287717',
    '10052713546021',
    '10052713578789',
    '10052713644325',
    '10052713677093',
    '10052713873701',
    '10052713906469',
    '10052714004773',
    '10052714070309',
    '10052714103077',
    '10052714135845',
    '10052714234149',
    '10052714266917',
    '10056518795557',
    '10056518926629',
    '10056518992165',
    '10056519090469',
    '10056519156005',
    '10060620988709',
    '10060621021477',
    '10060621087013',
    '10060621250853',
    '10060621283621',
    '10060621349157',
    '10060621381925',
    '10060621742373',
    '10060621938981',
    '10150321258789',
    '10150321324325',
    '10152801501477',
    '10152801534245',
    '10373118918949',
    '10373118984485',
    '10373119017253',
    '10373119082789',
    '10373119148325',
    '10375266533669',
    '10375266566437',
    '10375266599205',
    '10375266631973',
    '10375266664741',
    '10375266730277',
    '10375266795813',
    '10375266894117',
    '10375266926885',
    '10375266959653',
    '10375266992421',
    '10375267025189',
    '10375267057957',
    '10378338369829',
    '10378338402597',
    '10378338435365',
    '10378338468133',
    '10378338566437',
    '10378338631973',
    '10378338697509',
    '10378338763045',
    '10378338795813',
    '10378338828581',
    '10378338861349',
    '10378338959653',
    '10378338992421',
    '10411312447781',
    '10496610107685',
    '10630801588517',
    '10630806667557',
    '10630806700325',
    '10630806831397',
    '10630806864165',
    '10630807224613',
    '10630807290149',
    '10630807355685',
    '10630807388453',
    '10630807552293',
    '10630807585061',
    '10630807617829',
    '10630808076581',
    '10630808142117',
    '10630808207653',
    '10630809420069',
    '10630810173733',
    '10630810435877',
    '10630810468645',
    '10630810501413',
    '10630810698021',
    '10630810763557',
    '10630810796325',
    '10630810894629',
    '10630811189541',
    '10630811255077',
    '10630811681061',
    '10630811779365',
    '10630811877669',
    '8257434452261',
    '8257442087205',
    '8392719401253',
    '8669485728037',
    '8674714747173',
    '8846618263845',
    '8896433422629',
    '9017236062501',
    '9017394823461',
    '9235206045989',
    '9235207258405',
    '9235212108069',
    '9235215614245',
    '9235219415333',
    '9235237830949',
    '9579928224037',
    '9579928748325',
    '9596935569701',
    '9596935733541',
    '9622013083941',
    '9759161745701',
    '9759161811237',
    '9759760744741',
    '9759760843045',
    '9774498382117',
    '9870247133477',
    '9870247264549',
    '9870247297317',
    '9870247330085',
    '9887544017189',
    '9887544082725',
    '9887544574245'
  ]);
  var ELIGIBLE_PRODUCT_ID_SET = new Set(ELIGIBLE_PRODUCT_IDS);

  var DEFAULT_CONFIG = Object.freeze({
    enabled: false,
    dryRun: true,
    cartMutationAuthorised: false,
    activationState: 'PREPARED_ONLY',
    runtimeMode: 'DISABLED',
    targetThemeId: null,
    authoritySha256: AUTHORITY_SHA256,
    giftProductId: null,
    giftVariantId: null,
    legacyCleanupEnabled: false,
    eventDebounceMilliseconds: 120
  });

  var suppliedConfig = window.MJSGWP0074_CONFIG || {};
  var config = Object.assign({}, DEFAULT_CONFIG, suppliedConfig);
  var state = {
    inFlight: null,
    rerunRequested: false,
    eventTimer: null,
    lastAddedKey: '',
    status: 'disabled',
    lastResult: null
  };

  function normaliseShopifyId(value) {
    var match = String(value == null ? '' : value).match(/(\d+)$/);
    return match ? match[1] : '';
  }

  function activationGuard() {
    var giftVariantId = normaliseShopifyId(config.giftVariantId);
    var giftProductId = normaliseShopifyId(config.giftProductId);
    var targetThemeId = normaliseShopifyId(config.targetThemeId);
    var runtimeThemeId = normaliseShopifyId(
      window.Shopify && window.Shopify.theme && window.Shopify.theme.id
    );
    var hostname = String(window.location && window.location.hostname || '').toLowerCase();
    var isShopifyPreviewHost = /(^|\.)shopifypreview\.com$/u.test(hostname);
    var isProductionHostname = PRODUCTION_HOSTNAMES.indexOf(hostname) !== -1;
    var isExactTargetTheme = Boolean(targetThemeId && runtimeThemeId === targetThemeId);
    var isLiveState =
      config.runtimeMode === 'LIVE' &&
      config.activationState === REQUIRED_LIVE_ACTIVATION_STATE &&
      isExactTargetTheme &&
      isProductionHostname;
    var isPilotReleaseState =
      config.runtimeMode === 'PILOT_RELEASE' &&
      config.activationState === REQUIRED_PILOT_ACTIVATION_STATE &&
      isExactTargetTheme &&
      isProductionHostname;
    var isUnpublishedRcUatState =
      config.runtimeMode === 'UNPUBLISHED_RC_UAT' &&
      config.activationState === REQUIRED_UAT_ACTIVATION_STATE &&
      isExactTargetTheme &&
      isShopifyPreviewHost;
    var reasons = [];

    if (config.enabled !== true) reasons.push('enabled_must_be_true');
    if (config.dryRun !== false) reasons.push('dryRun_must_be_false');
    if (config.cartMutationAuthorised !== true) reasons.push('cart_mutation_not_authorised');
    if (!isLiveState && !isPilotReleaseState && !isUnpublishedRcUatState) {
      reasons.push('activation_state_not_satisfied');
    }
    if (config.authoritySha256 !== AUTHORITY_SHA256) reasons.push('authority_hash_mismatch');
    if (config.legacyCleanupEnabled !== true) reasons.push('legacy_cleanup_not_acknowledged');
    if (!giftProductId) reasons.push('gift_product_id_missing');
    if (!giftVariantId) reasons.push('gift_variant_id_missing');
    if (giftProductId === LEGACY_PRODUCT_ID) reasons.push('gift_product_is_legacy_gwp069');
    if (giftVariantId === LEGACY_VARIANT_ID) reasons.push('gift_variant_is_legacy_gwp069');

    return {
      active: reasons.length === 0,
      reasons: reasons,
      giftProductId: giftProductId,
      giftVariantId: giftVariantId
    };
  }

  var guard = activationGuard();

  function getRootRoute() {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    root = typeof root === 'string' && root ? root : '/';
    return root.charAt(root.length - 1) === '/' ? root : root + '/';
  }

  function cartRoute(path) {
    return getRootRoute() + String(path || '').replace(/^\/+/, '');
  }

  function dispatch(name, detail) {
    if (typeof window.dispatchEvent !== 'function' || typeof window.CustomEvent !== 'function') return;
    window.dispatchEvent(new window.CustomEvent(name, { detail: detail }));
  }

  function safeSessionGet(key) {
    try {
      return window.sessionStorage ? window.sessionStorage.getItem(key) : null;
    } catch (error) {
      return null;
    }
  }

  function safeSessionSet(key, value) {
    try {
      if (!window.sessionStorage) return;
      if (value == null || value === '') {
        window.sessionStorage.removeItem(key);
      } else {
        window.sessionStorage.setItem(key, value);
      }
    } catch (error) {
      // Storage is optional. Its failure must not weaken the server proof gate.
    }
  }

  async function requestJson(path, options) {
    var requestOptions = Object.assign(
      {
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json'
        }
      },
      options || {}
    );

    if (requestOptions.body) {
      requestOptions.headers = Object.assign({}, requestOptions.headers, {
        'Content-Type': 'application/json'
      });
    }

    var response = await window.fetch(cartRoute(path), requestOptions);
    if (!response || !response.ok) {
      var status = response && response.status ? response.status : 'network';
      throw new Error('Cart request failed for ' + path + ' with status ' + status + '.');
    }
    return response.json();
  }

  function fetchCart() {
    return requestJson('cart.js', { method: 'GET' });
  }

  function changeLine(identifier, quantity) {
    if (!identifier) return Promise.reject(new Error('Cart line identifier is required.'));
    return requestJson('cart/change.js', {
      method: 'POST',
      body: JSON.stringify({ id: identifier, quantity: quantity })
    });
  }

  async function addGift() {
    var result = await requestJson('cart/add.js', {
      method: 'POST',
      body: JSON.stringify({
        items: [
          {
            id: Number(guard.giftVariantId),
            quantity: 1,
            properties: {
              _mjs_gwp_campaign: 'fathers-day-2026-gwp0074',
              _mjs_gwp_sku: GIFT_SKU,
              _mjs_gwp_authority_sha256: AUTHORITY_SHA256
            }
          }
        ]
      })
    });

    var addedItem = result && Array.isArray(result.items) ? result.items[0] : result;
    state.lastAddedKey = addedItem && addedItem.key ? String(addedItem.key) : '';
    return result;
  }

  function lineProperties(item) {
    return item && item.properties && typeof item.properties === 'object' ? item.properties : {};
  }

  function isNewGift(item) {
    if (!item) return false;
    return normaliseShopifyId(item.variant_id || item.id) === guard.giftVariantId;
  }

  function isLegacyGift(item) {
    if (!item) return false;
    var properties = lineProperties(item);
    var legacyProperty = String(properties[LEGACY_PROPERTY_KEY] || '').toLowerCase();
    return (
      normaliseShopifyId(item.variant_id || item.id) === LEGACY_VARIANT_ID ||
      normaliseShopifyId(item.product_id) === LEGACY_PRODUCT_ID ||
      legacyProperty === LEGACY_PROPERTY_VALUE
    );
  }

  function isEligibleMerchandise(item) {
    if (!item || isNewGift(item) || isLegacyGift(item)) return false;
    return ELIGIBLE_PRODUCT_ID_SET.has(normaliseShopifyId(item.product_id));
  }

  function cartItems(cart) {
    return cart && Array.isArray(cart.items) ? cart.items : [];
  }

  function eligibleCartSignature(cart) {
    var eligible = cartItems(cart)
      .filter(isEligibleMerchandise)
      .map(function mapLine(item) {
        return [
          normaliseShopifyId(item.product_id),
          normaliseShopifyId(item.variant_id || item.id),
          Number(item.quantity || 0),
          Number(item.final_line_price || 0),
          Number(item.original_line_price || 0)
        ].join(':');
      })
      .sort();

    return String(cart && cart.currency ? cart.currency : '') + '|' + eligible.join('|');
  }

  function sumDiscountAllocations(item) {
    var allocations = item && Array.isArray(item.discount_allocations) ? item.discount_allocations : [];
    return allocations.reduce(function sum(total, allocation) {
      var amount = allocation && allocation.amount != null ? Number(allocation.amount) : 0;
      return total + (Number.isFinite(amount) ? amount : 0);
    }, 0);
  }

  function hasServerFreeGiftProof(item) {
    if (!isNewGift(item) || Number(item.quantity || 0) !== 1) return false;

    var originalLinePrice = Number(item.original_line_price);
    var finalLinePrice = Number(item.final_line_price);
    var lineLevelTotalDiscount = Number(item.line_level_total_discount || 0);
    var allocatedDiscount = sumDiscountAllocations(item);

    return (
      Number.isFinite(originalLinePrice) &&
      originalLinePrice > 0 &&
      Number.isFinite(finalLinePrice) &&
      finalLinePrice === 0 &&
      (lineLevelTotalDiscount > 0 || allocatedDiscount > 0)
    );
  }

  async function removeLines(lines) {
    var latestCart = null;
    for (var index = 0; index < lines.length; index += 1) {
      var line = lines[index];
      var identifier = line && (line.key || line.variant_id || line.id);
      if (identifier) latestCart = await changeLine(identifier, 0);
    }
    return latestCart;
  }

  async function removeLegacyLines(cart) {
    var lines = cartItems(cart).filter(isLegacyGift);
    if (!lines.length) return cart;
    await removeLines(lines);
    return fetchCart();
  }

  async function removeNewGiftLines(cart) {
    var lines = cartItems(cart).filter(isNewGift);
    if (!lines.length) return cart;
    await removeLines(lines);
    return fetchCart();
  }

  async function normaliseNewGift(cart) {
    var lines = cartItems(cart).filter(isNewGift);
    if (!lines.length) return cart;

    if (lines.length > 1) {
      await removeLines(lines.slice(1));
      cart = await fetchCart();
      lines = cartItems(cart).filter(isNewGift);
    }

    if (lines.length && Number(lines[0].quantity || 0) !== 1) {
      await changeLine(lines[0].key || lines[0].variant_id || lines[0].id, 1);
      cart = await fetchCart();
    }

    return cart;
  }

  async function failClosedCleanup() {
    var identifiers = [];
    if (state.lastAddedKey) identifiers.push(state.lastAddedKey);
    if (!identifiers.length && guard.giftVariantId) identifiers.push(guard.giftVariantId);

    for (var index = 0; index < identifiers.length; index += 1) {
      try {
        await changeLine(identifiers[index], 0);
        state.lastAddedKey = '';
        return true;
      } catch (error) {
        // Try the next safe identifier. The final failure is surfaced below.
      }
    }
    return false;
  }

  async function reconcileCart(reason) {
    var cart = await fetchCart();
    cart = await removeLegacyLines(cart);

    var eligibleLines = cartItems(cart).filter(isEligibleMerchandise);
    var newGiftLines = cartItems(cart).filter(isNewGift);

    if (!eligibleLines.length) {
      if (newGiftLines.length) cart = await removeNewGiftLines(cart);
      safeSessionSet(FAILED_PROBE_KEY, '');
      return { status: 'not_eligible_no_approved_merchandise', reason: reason, cart: cart };
    }

    var signature = eligibleCartSignature(cart);

    if (newGiftLines.length) {
      cart = await normaliseNewGift(cart);
      newGiftLines = cartItems(cart).filter(isNewGift);
      if (newGiftLines.length === 1 && hasServerFreeGiftProof(newGiftLines[0])) {
        safeSessionSet(FAILED_PROBE_KEY, '');
        state.lastAddedKey = '';
        return { status: 'retained_server_verified_free_gift', reason: reason, cart: cart };
      }

      cart = await removeNewGiftLines(cart);
      safeSessionSet(FAILED_PROBE_KEY, signature);
      return { status: 'removed_unverified_or_paid_gift', reason: reason, cart: cart };
    }

    if (safeSessionGet(FAILED_PROBE_KEY) === signature) {
      return { status: 'not_reprobed_unchanged_ineligible_cart', reason: reason, cart: cart };
    }

    await addGift();
    cart = await fetchCart();
    cart = await normaliseNewGift(cart);
    newGiftLines = cartItems(cart).filter(isNewGift);

    if (newGiftLines.length === 1 && hasServerFreeGiftProof(newGiftLines[0])) {
      safeSessionSet(FAILED_PROBE_KEY, '');
      state.lastAddedKey = '';
      return { status: 'added_and_server_verified_free_gift', reason: reason, cart: cart };
    }

    cart = await removeNewGiftLines(cart);
    safeSessionSet(FAILED_PROBE_KEY, signature);
    state.lastAddedKey = '';
    return { status: 'rejected_native_discount_did_not_prove_free', reason: reason, cart: cart };
  }

  async function runSync(reason) {
    if (!guard.active) {
      return { status: 'disabled', reasons: guard.reasons.slice(), reason: reason || 'manual' };
    }

    if (state.inFlight) {
      state.rerunRequested = true;
      return state.inFlight;
    }

    state.inFlight = (async function execute() {
      try {
        state.status = 'syncing';
        var result = await reconcileCart(reason || 'manual');
        state.status = result.status;
        state.lastResult = { status: result.status, reason: result.reason };
        dispatch('mjs:gwp0074:sync', state.lastResult);
        return result;
      } catch (error) {
        var cleanupSucceeded = await failClosedCleanup();
        var failure = {
          status: cleanupSucceeded ? 'error_fail_closed_cleanup_attempted' : 'error_cleanup_not_confirmed',
          reason: reason || 'manual',
          message: error && error.message ? error.message : String(error)
        };
        state.status = failure.status;
        state.lastResult = failure;
        dispatch('mjs:gwp0074:error', failure);
        return failure;
      } finally {
        state.inFlight = null;
      }
    })();

    var result = await state.inFlight;
    if (state.rerunRequested) {
      state.rerunRequested = false;
      return runSync('queued');
    }
    return result;
  }

  function queueSync(reason) {
    if (!guard.active) return;
    if (state.eventTimer) window.clearTimeout(state.eventTimer);
    state.eventTimer = window.setTimeout(function delayedSync() {
      state.eventTimer = null;
      runSync(reason || 'event');
    }, Number(config.eventDebounceMilliseconds || 120));
  }

  function registerListeners() {
    if (!guard.active || !window.document) return;

    ['cart:updated', 'cart:refresh', 'theme:cart:change', 'ajaxProduct:added', 'mjs:cart:changed'].forEach(
      function registerEvent(eventName) {
        window.document.addEventListener(eventName, function cartEventListener() {
          queueSync(eventName);
        });
      }
    );

    window.document.addEventListener('change', function cartFormChange(event) {
      var target = event && event.target;
      if (!target || typeof target.closest !== 'function') return;
      if (target.closest('form[action*="/cart"], cart-drawer, cart-items')) queueSync('cart-form-change');
    });

    if (typeof window.addEventListener === 'function') {
      window.addEventListener('pageshow', function pageShow() {
        queueSync('pageshow');
      });
    }

    if (window.document.readyState === 'loading') {
      window.document.addEventListener('DOMContentLoaded', function ready() {
        queueSync('dom-ready');
      });
    } else {
      queueSync('initial');
    }
  }

  window.MJSGWP0074 = Object.freeze({
    version: VERSION,
    sync: runSync,
    getDiagnostics: function getDiagnostics() {
      return {
        version: VERSION,
        status: state.status,
        active: guard.active,
        activationReasons: guard.reasons.slice(),
        authoritySha256: AUTHORITY_SHA256,
        eligibleProductIds: ELIGIBLE_PRODUCT_IDS.slice(),
        eligibleProductCount: ELIGIBLE_PRODUCT_IDS.length,
        giftSku: GIFT_SKU,
        giftProductId: guard.giftProductId,
        giftVariantId: guard.giftVariantId,
        legacySku: LEGACY_SKU,
        legacyProductId: LEGACY_PRODUCT_ID,
        legacyVariantId: LEGACY_VARIANT_ID,
        localeRoot: getRootRoute(),
        lastResult: state.lastResult
      };
    }
  });

  state.status = guard.active ? 'ready' : 'disabled';
  registerListeners();
})();
